export default __webpack_public_path__ + "static/SectionTwo_01_04-9bb04e5492f6591a5a92ebe7101c30fe.png";